{
  "Özlük": "Özlük",
  "ozluk": {
    "Personel Tanımınız Yok": "Personel Tanımınız Yok",
    "Özlük": "Özlük",
    "Güncelleme başarılı": "Güncelleme başarılı"
  }
}
